import React from "react"
import { compose, defaultProps } from "recompose"
import { Box } from "@infotech/uikit-grid"
import FieldSet from "@infotech/uikit-fieldset"
import InfinitySelect from "src/components/Selects/InfinitySelect"
import { CircleIcon } from "@infotech/uikit-extra-icons"
import style from "./style.css"

const createResourceDescription = extraInformation => {
  const spanTitle = extraInformation.split(`;`)
  return (
    <div className={style.resourceSelectDescription}>
      {spanTitle.map(title => (
        <span>{title}</span>
      ))}
    </div>
  )
}

const createResourceIcon = statusCode => {
  const colors = {
    FREE: `#31b237`,
    BUSY: `#ef4e4e`,
    CROSSING: `#e9b949`,
  }
  const resourceIcon = compose(
    defaultProps({
      style: {
        fill: colors[statusCode],
      },
    }),
  )(CircleIcon)

  return resourceIcon
}

const ResourceSelect = ({
  eventUuid,
  isNew,
  availableList,
  availableTotal,
  getTestAttribute,
  isDisabled,
  isResourcesDisabled,
  pending,
  addEventResource,
  availableQuery,
  setQuery,
  allowedResourceTypes,
}) => {
  const options = availableList.map(item => ({
    label: item.name,
    value: item.uuid,
    data: item,
    description:
      item.extraInformation && createResourceDescription(item.extraInformation),
    icon: item.statusCode && createResourceIcon(item.statusCode),
  }))
  const stopLoad = availableList.length >= availableTotal
  return (
    <Box p="2md">
      <FieldSet caption="Ресурсы">
        <div data-testid={getTestAttribute(`resource-multiselect`)}>
          <InfinitySelect
            placeholder="Введите название ресурса"
            isDisabled={isDisabled || pending || isNew || isResourcesDisabled}
            isLoading={pending}
            options={options}
            value={null}
            onChange={({
              target: {
                value: { value, data },
              },
            }) => {
              if (value && eventUuid) {
                addEventResource({
                  eventUuid,
                  resourceUuid: value,
                  resourceData: data,
                  availableQuery,
                })
              }
              return null
            }}
            infinityConfig={{
              searchExtraQuery: `resourceTypeId=in=(${allowedResourceTypes})`,
              searchBy: `name`,
              changeQuery: setQuery,
              queryParams: availableQuery,
              stopLoad,
            }}
          />
        </div>
      </FieldSet>
    </Box>
  )
}

export default ResourceSelect
